/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}      from '@/models/action';
import {Logger}                  from '@/util/logger';
import {WindowService}           from "@/services/window.service";
import {WorkBloxEditorMetadata}  from '@/screens/ide/work.blox.editor.metadata';

/**
 *
 * @class WorkBloxEditAction
 *
 * @brief launch a new / blank workbox editor
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class WorkBloxEditAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.workbloxeditor',
      type:  ActionType.Window_WorkBlox,
      label: 'Workblocks Editor (Empty)',
      icon:  '<i class="fas fa-snowplow"></i>',
      tip:   'Launch a workblocks editor'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WorkBloxEditAction] executing...');

    this.windows.launchWindow(new WorkBloxEditorMetadata(
      '',
      '',
      ''
    ));

    return true;
  }
}
